import { gettext } from '@eventbrite/i18n';
import {
    getFormValidationAdornment,
    TextField,
    Typography,
} from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppContext } from '../../../AppContext';
import { CreateAccountFormValues } from '../types';
import { isValidEmail } from '../utils';

export enum EmailFormFieldTestId {
    Field = 'CreateAccountEmailFormField',
}

export const EmailFormField = () => {
    const { control } = useFormContext<CreateAccountFormValues>();
    const { isSubmittingCreateAccountForm } = useAppContext();

    const emailMessage = gettext(
        'Please enter a valid email address.',
    ).toString();

    return (
        <Controller
            name="email"
            control={control}
            rules={{
                required: {
                    value: true,
                    message: emailMessage,
                },
                validate: {
                    validEmail: (value) => {
                        if (value && !isValidEmail(value)) {
                            return emailMessage;
                        }
                        return true;
                    },
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <>
                    <TextField
                        autoComplete="off"
                        autoFocus
                        data-testid={EmailFormFieldTestId.Field}
                        hasError={!!error}
                        helperText={error && error.message}
                        id="create-account-email"
                        label={gettext('Email address').toString()}
                        maxLength={100}
                        validationAdornment={getFormValidationAdornment({
                            hasError: !!error,
                        })}
                        {...field}
                        value={field.value || ''}
                        onChange={(value) => {
                            field.onChange({
                                target: { value },
                            });
                        }}
                        disabled={isSubmittingCreateAccountForm}
                        required
                    />
                    {!error && field.value && !isValidEmail(field.value) && (
                        <Typography as="p" variant="body-sm">
                            {emailMessage}
                        </Typography>
                    )}
                </>
            )}
        />
    );
};
